import { Tooltip } from "@chakra-ui/react";
import Button from "../Button/Button";
import CSS from "./styles.module.css";

const QuestionBox = ({ data, index, id, isActive }) => {
	return (
		<div className={CSS.QuestionBox}>
			<div className={`${CSS.InfoButton} HiddenContent2`}>
				<Tooltip
					label={data.context}
					placement="top-end"
					hasArrow
					contentEditable={false}
				>
					<div onClick="">
						<Button variant="SmallButton" leftIcon="info" />
					</div>
				</Tooltip>
			</div>
			<div className={CSS.EditableContainer}>
				<div className={CSS.QuestionContainer} id={id}>
					<span className={CSS.Question}>
						{index + 1}.&nbsp;{data.question}
					</span>
					{isActive && (
						<p className={CSS.AnswerText}>
							<font>Answer:&nbsp;</font>
							{data.answer}
						</p>
					)}
				</div>
			</div>
		</div>
	);
};

export default QuestionBox;
